import { jsx } from "react/jsx-runtime";
import Card from "antd/es/card/Card";
import classnames from "../../utils/classnames.js";
import CarTileButtonTooltip from "./CarTileButtonTooltip.js";
import CarTileGallery from "./CarTileGallery.js";
import CarTileImage from "./CarTileImage.js";
import CarTileImageSkeleton from "./CarTileImageSkeleton.js";
import CarTileLocation from "./CarTileLocation.js";
import CarTileLocationSkeleton from "./CarTileLocationSkeleton.js";
import CarTileMarkers from "./CarTileMarkers.js";
import CarTileMarkersSkeleton from "./CarTileMarkersSkeleton.js";
import CarTilePayment from "./CarTIlePayment.js";
import CarTilePaymentSkeleton from "./CarTilePaymentSkeleton.js";
import CarTilePrice from "./CarTilePrice.js";
import CarTilePriceSkeleton from "./CarTilePriceSkeleton.js";
import CarTileStatus from "./CarTileStatus.js";
import CarTileStatusSkeleton from "./CarTileStatusSkeleton.js";
import CarTileTable from "./CarTileTable.js";
import CarTileTableSkeleton from "./CarTileTableSkeleton.js";
import CarTileTitle from "./CarTileTitle.js";
import CarTileTitleSkeleton from "./CarTileTitleSkeleton.js";
import './CarTile.css';/* empty css             */
const CarTile = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx(Card, { hoverable: true, className: classnames("perxis-auto-car-tile", className), ...props, children });
};
CarTile.Image = CarTileImage;
CarTile.ImageSkeleton = CarTileImageSkeleton;
CarTile.Table = CarTileTable;
CarTile.TableSkeleton = CarTileTableSkeleton;
CarTile.Title = CarTileTitle;
CarTile.TitleSkeleton = CarTileTitleSkeleton;
CarTile.Location = CarTileLocation;
CarTile.LocationSkeleton = CarTileLocationSkeleton;
CarTile.Price = CarTilePrice;
CarTile.PriceSkeleton = CarTilePriceSkeleton;
CarTile.Payment = CarTilePayment;
CarTile.PaymentSkeleton = CarTilePaymentSkeleton;
CarTile.Markers = CarTileMarkers;
CarTile.MarkersSkeleton = CarTileMarkersSkeleton;
CarTile.Status = CarTileStatus;
CarTile.StatusSkeleton = CarTileStatusSkeleton;
CarTile.ButtonTooltip = CarTileButtonTooltip;
CarTile.Gallery = CarTileGallery;
export {
  CarTile as default
};
//# sourceMappingURL=CarTile.js.map
